import React from "react";
import { Box, Typography } from "@mui/material";
import { boxStyles, titleStyles, contentStyles } from "./NoteStyle"; // Import styles
import { useSelector } from "react-redux";
import { darkTheme } from "../../../theme/Theme";

export default function Notes({ headerText, notes }) {
  const isDarkTheme = useSelector((state) => state.theme);
  return (
    <Box
      sx={{
        ...boxStyles,
        background: isDarkTheme
          ? darkTheme.insideCardBackgroundColorLayer3
          : "var(--Tokens-Background-Layer-02, #EFF5FC)",
      }}
    >
      <Typography
        sx={{
          ...titleStyles,
          color: isDarkTheme
            ? "white"
            : "var(--Tokens-Text-Secondary, #616161)",
        }}
      >
        {headerText} {headerText === "Denied" ? "reason" : "Notes"}
      </Typography>
      <Typography
        sx={{
          ...contentStyles,
          color: isDarkTheme
            ? "white"
            : "var(--Tokens-Text-Secondary, #616161)",
        }}
        dangerouslySetInnerHTML={{ __html: notes || "" }}
      />
    </Box>
  );
}
